export const SET_HRES89U_INDEX_DISP = 'SET_HRES89U_INDEX_DISP'
export const GET_HRES89U_INDEX_DISP = 'GET_HRES89U_INDEX_DISP'
export const SET_HRES89U_DETAIL_DISP = 'SET_HRES89U_DETAIL_DISP'
export const GET_HRES89U_DETAIL_DISP = 'GET_HRES89U_DETAIL_DISP'
export const SET_HRES89U_MAX_ROWSPAN = 'SET_HRES89U_MAX_ROWSPAN'
export const GET_HRES89U_MAX_ROWSPAN = 'GET_HRES89U_MAX_ROWSPAN'
export const SET_HRES89U_COLUMNS = 'SET_HRES89U_COLUMNS'
export const GET_HRES89U_COLUMNS = 'GET_HRES89U_COLUMNS'
export const SET_HRES89U_LABELS = 'SET_HRES89U_LABELS'
export const GET_HRES89U_LABELS = 'GET_HRES89U_LABELS'
export const RECEIVED_HRES89U_COLUMNS_LABELS = 'RECEIVED_HRES89U_COLUMNS_LABELS'
export const SET_HRES89U_INDEX = 'SET_HRES89U_INDEX'
export const GET_HRES89U_INDEX = 'GET_HRES89U_INDEX'
export const RECEIVED_HRES89U_INDEX = 'RECEIVED_HRES89U_INDEX'
export const SET_HRES89U_INDEX_SELECTED = 'SET_HRES89U_INDEX_SELECTED'
export const GET_HRES89U_INDEX_SELECTED = 'GET_HRES89U_INDEX_SELECTED'
export const SET_HRES89U_DETAIL = 'SET_HRES89U_DETAIL'
export const GET_HRES89U_DETAIL = 'GET_HRES89U_DETAIL'
export const RECEIVED_HRES89U_DETAIL = 'RECEIVED_HRES89U_DETAIL'
export const SET_HRES89U_DETAIL_SUBMIT = 'SET_HRES89U_DETAIL_SUBMIT'
export const GET_HRES89U_DETAIL_SUBMIT = 'GET_HRES89U_DETAIL_SUBMIT'
export const RECEIVED_HRES89U_DETAIL_SUBMIT = 'RECEIVED_HRES89U_DETAIL_SUBMIT'
export const TOGGLE_HRES89U_PAGE = 'TOGGLE_HRES89U_PAGE'
export const POST_HRES89U_SEND_APPROVE = 'POST_HRES89U_SEND_APPROVE'
export const RECEIVED_HRES89U_DROPDOWNS = 'RECEIVED_HRES89U_DROPDOWNS'
export const SET_HRES89U_DROPDOWNS = 'SET_HRES89U_DROPDOWNS'
export const GET_HRES89U_DROPDOWNS = 'GET_HRES89U_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/hres89u/mutation-types.js